<div class="container-fluid">
  <div class="row">
    <div class="col-sm-6">
      <h3 class="h3-custom">
        {{ 'label.AnnouncementMatchedJobseekers' | translate }}
      </h3>
    </div>
    <div class="col-sm-6">
      <button
        (click)="onListClick(dt)"
        class="btn btn-success btn-custom-fLeft"
      >
        {{ 'label.ShowAllGeneratedMatches' | translate }}
      </button>
      <div class="btn-custom-fRight">
        <hr-matching-generate-on-announcement
          [display]="displayModal"
          (onAdd)="onGenerate($event)"
          (onClose)="onClose($event)"
          (onUpdate)="onUpdateTable($event)"
        >
        </hr-matching-generate-on-announcement>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-12">
      <p-table
        #dt
        [columns]="cols"
        showGridlines
        [value]="matchedAnnouncements"
        [rowHover]="true"
        [paginator]="true"
        [rows]="pageSize"
        [totalRecords]="totalRecords"
        [lazy]="true"
        (onLazyLoad)="onLoad($event)"
      >
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th
              *ngFor="let col of columns"
              [ngStyle]="{
                overflow: 'hidden',
                'text-align': 'center',
                width:
                  col.header == 'Portfolio'
                    ? '13%'
                    : col.header == 'PublishDate'
                    ? '10%'
                    : col.header == 'AnnouncementTitle'
                    ? '17%'
                    : col.header == 'Company'
                    ? '15%'
                    : col.header == 'Status'
                    ? '10%'
                    : col.header == 'Matches' ||
                      col.header == 'ToSend' ||
                      col.header == 'Rejected'
                    ? '7%'
                    : col.header == 'ApproveAndSend'
                    ? '13%'
                    : '3%'
              }"
            >
              {{
                col.header !== '?' ? ('label.' + col.header | translate) : '?'
              }}
            </th>
          </tr>
          <tr>
            <th *ngFor="let col of columns" [ngSwitch]="col.field">
              <input
                *ngSwitchCase="'announcementTitle'"
                pInputText
                type="text"
                (input)="dt.filter($event.target.value, col.field, 'contains')"
                class="form-control"
                style="width: 100%"
                [(ngModel)]="announcementTitleFilter"
              />
              <input
                *ngSwitchCase="'companyName'"
                pInputText
                type="text"
                (input)="dt.filter($event.target.value, col.field, 'contains')"
                class="form-control"
                style="width: 100%"
                [(ngModel)]="companyNameFilter"
              />
              <p-dropdown
                *ngSwitchCase="'label.Status' | translate"
                [options]="statuses"
                [style]="{ width: '100%' }"
                (onChange)="dt.filter($event.value, col.field, 'equals')"
                [(ngModel)]="approvalStatusIdFilter"
              ></p-dropdown>
              <p-dropdown
                *ngSwitchCase="'label.portfolio' | translate"
                [options]="portfolios"
                [style]="{ width: '100%' }"
                (onChange)="dt.filter($event.value, col.field, 'equals')"
                [(ngModel)]="portfolioIdFilter"
              ></p-dropdown>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <tr
            [pSelectableRow]="rowData"
            [ngClass]="{ 'row-highlight': rowData['isHighlight'] }"
          >
            <td
              *ngFor="let col of columns"
              style="
                text-align: center;
                word-break: break-word;
                overflow: hidden;
              "
            >
              <span *ngIf="col.field == 'publishDate'">
                {{ rowData[col.field] | date : dateFormat }}
              </span>
              <span *ngIf="col.field == 'announcementTitle'">
                <a
                  [routerLink]="[
                    '../announcement-matching-list',
                    rowData['announcementMatchingListId']
                  ]"
                  >{{ rowData[col.field] }}</a
                >
              </span>
              <span
                *ngIf="
                  col.field != 'status' &&
                  col.field != 'announcementTitle' &&
                  col.field != 'publishDate'
                "
                >{{ rowData[col.field] }}</span
              >
              <span *ngIf="col.field == 'status'">{{
                'label.' +
                  announcementMatchingListApprovalStatus[rowData[col.field]]
                  | translate
              }}</span>
              <span *ngIf="col.field == 'approveAndSend'">
                <button
                  [disabled]="
                    !hasViewMatchingListPermission ||
                    !hasApproveMatchingListPermission ||
                    !hasExpressApprovePermission
                  "
                  class="btn btn-primary"
                  (click)="onApprove(rowData['announcementMatchingListId'])"
                >
                  {{ 'label.ExpressApprove' | translate }}
                </button>
              </span>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
